import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Manually marked as sold on the site only (not registered as sold in Stripe).
 */
const MANUALLY_SOLD_SLUGS = [
  'distressed-military-overshirt',
  'palace-theatre-distressed-sweatshirt-blue',
  'palace-theatre-distressed-hoodie',
  'washed-grey-chore-jacket',
  'paint-splattered-blazer',
];

/** Slugs of products that have already been sold (1 of each exists). */
export const useSoldProducts = () => {
  const { data } = useQuery({
    queryKey: ['sold-products'],
    queryFn: async () => {
      const { data, error } = await supabase.from('sold_products').select('slug');
      if (error) throw error;
      return (data ?? []).map((row) => row.slug as string);
    },
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });

  const soldSlugs = Array.from(new Set([...(data ?? []), ...MANUALLY_SOLD_SLUGS]));
  return {
    soldSlugs,
    isSold: (slug: string) => soldSlugs.includes(slug),
  };
};

